<template>
  <div>
    <v-text-field
      v-model="formData.kv"
      label="KV"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="generateAdminList"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading admin list
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading && data.vessel"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h1 class="report-title">LIST ADMIN</h1>
        </div>
        <div class="right">
          <h1 class="d-block">
            {{ data.vessel.nama_kapal }} - {{ data.vessel.voy }}
          </h1>
          <h3>Kode Vessel: {{ data.vessel.kv }}</h3>
        </div>
        <div class="tanggal">
          <h4 class="m-auto">{{ formatDate(data.vessel.tgl_berangkat) }}</h4>
        </div>
      </div>

      <!-- <div v-for="jenis in data.ttb" :key="jenis.jenis" class="page-break">
        <h2>Jenis Container: {{ jenis.jenis }}</h2>
        <div v-for="tagihan in jenis.items" :key="tagihan.title">
          <h3 v-if="tagihan.title != 'Lunas'">
            TAGIHAN DITAGIH KE {{ tagihan.title }} -
            <template v-if="tagihan.title == 'Pengirim'">"P"</template
            ><template v-if="tagihan.title == 'Penerima'">"ND"</template>
          </h3>
          <h3 v-else>LUNAS</h3>

          <div v-for="tujuanTagih in tagihan.data" :key="tujuanTagih.title">
            <p class="mt-2">
              <i>Ditagih Kepada :</i> <b>{{ tujuanTagih.title }}</b>
            </p>

            <table class="mb-4">
              <thead>
                <th>TTB</th>
                <th>NoCont</th>
                <th>KC</th>
                <th></th>
                <th>Tujuan</th>
                <th>Kondisi</th>
                <th>Pengirim</th>
                <th>Penerima</th>
                <th>Cargo</th>
                <th>Koli</th>
                <th>M3</th>
                <th>Ton</th>
                <th>No Nota</th>
              </thead>
              <tbody>
                <template
                  v-for="ttb in tujuanTagih.data"
                  :class="[ttb.koli_in != ttb.total_koli ? 'text-danger' : '']"
                >
                  <tr
                    v-for="containerDetil in ttb.container_detil"
                    :key="containerDetil.id"
                  >
                    <td>{{ ttb.nottb }}</td>
                    <td>
                      {{ containerDetil.container.no_container }}
                    </td>
                    <td>
                      {{ containerDetil.kc }}
                    </td>
                    <td>
                      {{ containerDetil.container.kondisi_stuffing }}
                    </td>
                    <td v-if="ttb.tujuan_detil">{{ ttb.tujuan_detil.kota }}</td>
                    <td v-else>-</td>
                    <td v-if="ttb.kondisi_detil">
                      {{ ttb.kondisi_detil.kondisi }}
                    </td>
                    <td v-else>-</td>
                    <td v-if="ttb.pengirim_detil">
                      {{ ttb.pengirim_detil.nama_lengkap }}
                    </td>
                    <td v-else>-</td>
                    <td v-if="ttb.penerima_detil">
                      {{ ttb.penerima_detil.nama_lengkap }}
                    </td>
                    <td v-else>-</td>
                    <td>
                      {{ containerDetil.container.cargo }}
                    </td>
                    <td v-if="ttb.ttb_rinci">
                      {{ ttb.koli_in }}
                    </td>
                    <td v-else>-</td>
                    <td v-if="ttb.ttb_rinci">
                      {{ countTotalM3(ttb.ttb_rinci) }}
                    </td>
                    <td v-else>-</td>
                    <td v-if="ttb.ttb_rinci">
                      {{ countTotalTon(ttb.ttb_rinci) }}
                    </td>
                    <td v-else>-</td>
                    <td class="text-center">{{ ttb.nomor_nota }}</td>
                  </tr>
                </template>
              </tbody>
              <tr>
                <td colspan="13" class="border-bottom"></td>
              </tr>
              <tr>
                <td colspan="3">
                  <b
                    >Total Container:
                    {{ countTotalContainer(tujuanTagih.data) }}</b
                  >
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ sumKoli(tujuanTagih.data) }}</td>
                <td>{{ sumM3(tujuanTagih.data) }}</td>
                <td>{{ sumTon(tujuanTagih.data) }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div> -->

      <div v-for="tagihan in data.ttb" :key="tagihan.title">
        <h3 v-if="tagihan.title != 'Lunas'">
          TAGIHAN DITAGIH KE {{ tagihan.title }} -
          <template v-if="tagihan.title == '1. Pengirim'">"P"</template
          ><template v-if="tagihan.title == '2. Penerima'">"ND"</template>
        </h3>
        <h3 v-else>LUNAS</h3>

        <div v-for="tujuanTagih in tagihan.data" :key="tujuanTagih.title">
          <p class="mt-2">
            <i>Ditagih Kepada :</i> <b>{{ tujuanTagih.title }}</b>
          </p>

          <table class="mb-4">
            <thead>
              <th width="5%">TTB</th>
              <th width="5%">JenisCont</th>
              <!-- <th>NoCont</th> -->
              <th width="5%">KC</th>
              <th width="10%">Kondisi Stuffing</th>
              <th width="5%">Tujuan</th>
              <th width="5%">Kondisi</th>
              <th width="10%">Pengirim</th>
              <th width="10%">Penerima</th>
              <th width="10%">Cargo</th>
              <th width="5%">Koli</th>
              <th width="5%">M3</th>
              <th width="5%">Ton</th>
              <th width="5%">No Nota</th>
              <th width="10%">Nominal Nota</th>
            </thead>
            <tbody>
              <template
                v-for="ttb in tujuanTagih.data"
                :class="[ttb.koli_in != ttb.total_koli ? 'text-danger' : '']"
              >
                <tr
                  v-for="containerDetil in ttb.container_detil"
                  :key="containerDetil.id"
                >
                  <td>{{ ttb.nottb }}</td>
                  <td>{{ containerDetil.container.jenis_container }}</td>
                  <!-- <td>
                    {{ containerDetil.container.no_container }}
                  </td> -->
                  <td>
                    {{ containerDetil.kc }}
                  </td>
                  <td>
                    {{ containerDetil.container.kondisi_stuffing }}
                  </td>
                  <td v-if="ttb.tujuan_detil">{{ ttb.tujuan_detil.kota }}</td>
                  <td v-else>-</td>
                  <td v-if="ttb.kondisi_detil">
                    {{ ttb.kondisi_detil.kondisi }}
                  </td>
                  <td v-else>-</td>
                  <td v-if="ttb.pengirim_detil">
                    {{ ttb.pengirim_detil.nama_lengkap }}
                  </td>
                  <td v-else>-</td>
                  <td v-if="ttb.penerima_detil">
                    {{ ttb.penerima_detil.nama_lengkap }}
                  </td>
                  <td v-else>-</td>
                  <td>
                    {{ formatCargo(ttb.ttb_detil) }}
                  </td>
                  <td v-if="ttb.ttb_rinci">
                    {{ ttb.koli_in }}
                  </td>
                  <td v-else>-</td>
                  <td v-if="ttb">
                    {{ countTotalM3(ttb) }}
                  </td>
                  <td v-else>-</td>
                  <td v-if="ttb">
                    {{ countTotalTon(ttb) }}
                  </td>
                  <td v-else>-</td>
                  <td class="text-center">{{ ttb.nomor_nota }}</td>
                  <td class="text-center">
                    {{ formatCurrency(ttb.nominal_nota) }}
                  </td>
                </tr>
              </template>
            </tbody>
            <tr>
              <td colspan="12" class="border-bottom"></td>
            </tr>
            <tr>
              <td colspan="3">
                <!-- <b
                  >Total Container:
                  {{ countTotalContainer(tujuanTagih.data) }}</b
                > -->
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ sumKoli(tujuanTagih.data) }}</td>
              <td>{{ sumM3(tujuanTagih.data) }}</td>
              <td>{{ sumTon(tujuanTagih.data) }}</td>
            </tr>
          </table>
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.vessel"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        kv: ""
      },
      data: {}
    };
  },
  watch: {
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async generateAdminList() {
      this.state.loading = true;

      await axios
        .get(`laporan/admin-list?kv=${this.formData.kv}`)
        .then(res => {
          this.state.loading = false;
          // console.log(res.data);

          if (!res.data.vessel) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    countTotalKoli(data) {
      let total = 0;

      data.forEach(el => {
        total += parseInt(el.koli);
      });

      return total;
    },
    countTotalM3(data) {
      let koliIn = parseInt(data.koli_in);
      let totalKoli = 0;
      let totalM3 = 0;

      data.ttb_rinci.forEach(el => {
        totalKoli += parseInt(el.koli);
        totalM3 += parseFloat(el.m3);
      });

      if (totalM3 == 0) return 0;

      let total = (koliIn / totalKoli) * totalM3;
      return total.toFixed(2);
    },
    countTotalTon(data) {
      let koliIn = parseInt(data.koli_in);
      let totalKoli = 0;
      let totalTon = 0;

      data.ttb_rinci.forEach(el => {
        totalKoli += parseInt(el.koli);
        totalTon += parseFloat(el.ton);
      });

      if (totalTon == 0) return 0;

      let total = (koliIn / totalKoli) * totalTon;
      return total.toFixed(2);
    },
    sumKoli(data) {
      let total = 0;

      data.forEach(el => {
        total += parseInt(el.koli_in);
      });

      return total;
    },
    sumM3(data) {
      let total = 0;

      data.forEach(el => {
        total += parseFloat(this.countTotalM3(el));
      });

      return total.toFixed(2);
    },
    sumTon(data) {
      let total = 0;

      data.forEach(el => {
        total += parseFloat(this.countTotalTon(el));
      });

      return total.toFixed(2);
    },
    formatCargo(data) {
      let text = [];

      data.forEach(el => {
        text.push(el.nama_barang);
      });

      return text.join(" / ");
    },
    countTotalContainer(data) {
      const kcArr = [];
      let total = 0;

      data.forEach(el => {
        el.container_detil.forEach(cont => {
          if (cont) {
            if (!kcArr.includes(cont.kc)) {
              total += 1;

              kcArr.push(cont.kc);
            }
          }
        });
      });

      return total;
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  }
};
</script>

<style type="text/css" media="print">
div.page-break {
  page-break-after: always !important;
  page-break-inside: avoid !important;
}
</style>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
  font-size: 14px;
}

.report .report-title {
  text-decoration: underline;
}

.header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid black;
  margin-bottom: 1.5rem;
}

.header .left {
  width: 60%;
}

.header .right {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.tanggal {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

table {
  width: 100%;
}

table th {
  font-style: italic;
  text-align: left;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}

.line {
  display: block;
  width: 100%;
  border-bottom: 1px solid black;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.text-danger {
  color: red !important;
}

@media print {
  #section-print {
    width: 85%;
  }

  .right h1 {
    font-size: 1rem;
  }

  table th,
  table td {
    font-size: 11px;
  }
}
</style>
